import { useMemo } from "react";

import defaultColors from "@/configs/themes/colors";
import { useAuthStore } from "@/features/Auth";

export const useColorScheme = () => {
  const userColors = useAuthStore(state => state.whiteLabel?.colors);

  return useMemo(() => userColors || defaultColors, [userColors]);
};
